class DaoBase {
    constructor(json=null) {
        this.serialize(json);
    }

    serialize(json) {
        if(json) {
            for(const k in json) {
                this[k] = json[k];
            }
        }
        json = null;
        return this;
    }

}

export default DaoBase;


// WEBPACK FOOTER //
// ./src/modules/dao/base.js